<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

const { openConfirmAlert } = useUserMessages();

async function promptReset() {
  const confirmed = await openConfirmAlert(t('settings.general.resetSettings'), t('settings.general.resetSettingsConfirm'), t('buttons.yes'));

  if (confirmed) {
    settingsStore.clearDeviceAndCurrentUserSettings();
  } 
}

</script>

<template>
  <IonButton
    class="ion-margin"
    expand="block"
    shape="round"
    fill="outline"
    @click="promptReset"
  >
    <IonLabel class="ion-text-center">
      {{ t('settings.general.resetSettings') }}
    </IonLabel>
  </IonButton>
</template>
